import { ButtonSetComponent } from './../button/button-set/button-set.component';
import { Component, OnInit, QueryList, ViewChildren, ViewChild, ElementRef, EventEmitter, Output, OnDestroy, Input } from '@angular/core';
import { IconButtonComponent } from '../icon-button/icon-button.component';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { IMapMemory } from 'src/app/types/@types/sl-v-types';

@Component({
	selector: 'app-memory-tools',
	templateUrl: './memory-tools.component.html',
	styleUrls: ['./memory-tools.component.scss']
})
export class MemoryToolsComponent implements OnInit, OnDestroy {


	private subcriptions: SubScriptionMgr = new SubScriptionMgr();
	public selectedAction: string;
	public memory: IMapMemory;

	public hasRemembered = false;
	public noRemembered = false;
	@Input() btnSize = 'md';
  @Input() hasSelResults:boolean = false;
  @Input() hasUnselResults:boolean = false;
	// tslint:disable-next-line: variable-name
	@ViewChild('buttonSet', { static: true }) buttonSet: ButtonSetComponent;
	@Output() actions: EventEmitter<any> = new EventEmitter<any>();
	constructor(private domNode: ElementRef) { }

	ngOnInit() {

	}
  UpdateHeight() {
    this.buttonSet.UpdatePosition();
  }
	SetMap(map: ISLMap) {
		this.memory = map.memory;
		this.subcriptions.Subscribe(this.memory.changes, () => {
			this.hasRemembered = this.memory.featureCount > 0;

		});
	}
  SelectTool(tool:string) {
    this.actions.emit({ memoryAction: tool });
  }

	ngOnDestroy(): void {
		this.subcriptions.CancelSubscriptions();
	}
}
